import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { surveyCreatorSelectors } from 'redux/slices/surveyCreatorSlice';
import { ControlledSelect } from '@act/storybook';

interface INextQuestionSelectorProps {
  questionKey: string;
  nextQuestionKey?: string;
  onChange: (nextQuestionKey: string) => void;
}

const NextQuestionSelector = ({
  questionKey,
  nextQuestionKey,
  onChange,
}: INextQuestionSelectorProps) => {
  const currentContent =
    surveyCreatorSelectors.useSelectSurveyCreatorCurrentContent();

  const availableQuestions =
    currentContent.surveyContent.surveyVersion.questions.filter(
      question => question.key !== questionKey
    );

  const { control, watch } = useForm<{
    selectedNextQuestionKey: string;
  }>({
    defaultValues: {
      selectedNextQuestionKey: nextQuestionKey,
    },
  });

  const selectedNextQuestionKey = watch('selectedNextQuestionKey');

  useEffect(() => {
    if (selectedNextQuestionKey) {
      onChange(selectedNextQuestionKey);
    } else {
      onChange(undefined);
    }
  }, [selectedNextQuestionKey]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        margin: '8px 0',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="bodyLarge">Next Question</Typography>
      </Box>
      {availableQuestions?.length > 0 && (
        <Box
          component="div"
          sx={{
            width: '100%',
            display: 'block',
            padding: '8px 0 16px',
            borderBottom: '1px solid',
            borderColor: 'divider',
            boxSizing: 'border-box',
          }}
        >
          <ControlledSelect
            name={'selectedNextQuestionKey'}
            label={'Choose a question to jump to'}
            control={control}
            options={[
              {
                label: 'Select a record to edit',
                value: '',
              },
              ...availableQuestions.map(question => ({
                label: `${question.text || 'Needs question text'} - (${
                  question.key
                })`,
                value: question.key,
              })),
            ]}
            fullWidth
          />
        </Box>
      )}
      {availableQuestions?.length === 0 && (
        <Typography variant="bodyLarge">
          There are no other questions. Try adding more.
        </Typography>
      )}
    </Box>
  );
};

export default NextQuestionSelector;
